import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { Play } from "lucide-react";
import { MEDIA } from "@/lib/content";

const Badge = () => (
  <div className="pointer-events-none absolute -left-3 -top-6 z-20 h-24 w-24 sm:-left-14 sm:top-10 sm:h-32 sm:w-32" aria-hidden="true">
    <svg viewBox="0 0 120 120" className="spin-slow h-full w-full">
      <defs><path id="circ" d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" /></defs>
      <circle cx="60" cy="60" r="58" fill="#070605" stroke="#2a2216" />
      <text fill="#c79a4b" fontSize="8.2" fontFamily="Montserrat" fontWeight="600">
        <textPath href="#circ" textLength="286" lengthAdjust="spacing">RISERVATO ALLE TITOLARI · 2 SERATE LIVE · </textPath>
      </text>
    </svg>
    <span className="absolute inset-0 flex items-center justify-center font-serif text-2xl text-gold-light">✦</span>
  </div>
);

export const HeroVideo = ({ parallaxY }) => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [9, -9]), { stiffness: 120, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-11, 11]), { stiffness: 120, damping: 18 });
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <motion.div style={{ y: parallaxY }} className="relative mx-auto w-full max-w-[340px] [perspective:1200px]" onMouseMove={onMove} onMouseLeave={reset}>
      <Badge />
      <motion.div
        initial={{ opacity: 0, scale: 0.92, clipPath: "inset(12% 12% 12% 12% round 28px)" }}
        animate={{ opacity: 1, scale: 1, clipPath: "inset(0% 0% 0% 0% round 28px)" }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1], delay: 0.5 }}
        style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
        className="relative aspect-[9/16] overflow-hidden rounded-[28px] border border-gold/40 bg-ink2 shadow-[0_40px_120px_-30px_rgba(199,154,75,0.45)]"
        data-testid="hero-video-frame"
      >
        {MEDIA.heroVideo ? (
          <video src={MEDIA.heroVideo} autoPlay muted loop playsInline className="h-full w-full object-cover" data-testid="hero-video" />
        ) : (
          <div className="relative flex h-full w-full flex-col justify-end bg-[radial-gradient(120%_70%_at_50%_20%,rgba(199,154,75,0.38),transparent_60%),linear-gradient(180deg,#1c150c,#070605)] p-6">
            <div className="absolute left-1/2 top-[38%] flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-gold-light/50 bg-ink/40 backdrop-blur-md">
              <span className="absolute inset-0 animate-ping rounded-full border border-gold/30" />
              <Play className="ml-1 h-7 w-7 fill-gold-light text-gold-light" />
            </div>
            <small className="text-[11px] uppercase tracking-[0.2em] text-sand">Reel · autoplay senza audio</small>
            <strong className="mt-2 font-serif text-3xl font-semibold leading-tight text-cream">Il Metodo Skin Lovers, dal vivo</strong>
          </div>
        )}
        <div className="pointer-events-none absolute inset-0 rounded-[28px] ring-1 ring-inset ring-white/5" />
      </motion.div>
    </motion.div>
  );
};
